<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="ffu-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="ffu-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-end>
        <v-flex xs12 sm6>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm6>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
      </v-layout>

      <!-- Dashboard filters -->
      <v-layout row wrap>
        <v-flex xs12>
          <filters
            :dashboard-id="id"
            @apply-filters="fetchDashboardData"
            @clear-filters="fetchDashboardData">
          </filters>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <!--KPI-->
      <v-layout row wrap justify-center>
        <v-flex xs12 sm10 lg6 v-if="hideCharts.indexOf('DataQuality_kpiTotalContacts') === -1">
          <widget-kpi
            widget-key="DataQuality_kpiTotalContacts">
          </widget-kpi>
        </v-flex>
      </v-layout>

      <!-- Dashboard Charts -->
      <v-layout row wrap justify-center>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validEmail') === -1">
          <chart-bar
            chart-key="DataQuality_validEmail"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validTelephone') === -1">
          <chart-bar
            chart-key="DataQuality_validTelephone"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validZip') === -1">
          <chart-bar
            chart-key="DataQuality_validZip"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validCity') === -1">
          <chart-bar
            chart-key="DataQuality_validCity"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validStreet') === -1">
          <chart-bar
            chart-key="DataQuality_validStreet"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validAddress') === -1">
          <chart-bar
            chart-key="DataQuality_validAddress"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12 md6 v-if="hideCharts.indexOf('DataQuality_validStreetNumber') === -1">
          <chart-bar
            chart-key="DataQuality_validStreetNumber"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>

      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
// import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
import am4themesMaterial from '@amcharts/amcharts4/themes/material'
import { am4themesEfdThemeAchr } from '@/themes'
// import moment from 'moment'

import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
import Filters from './DashboardDataQualityContactFilterGen'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartBar from '@/components/charts/ChartBar'
import ChartBarRender from '@/components/charts/ChartBarRender'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartPie from '@/components/charts/ChartPie'
import ChartPieRender from '@/components/charts/ChartPieRender'
import ChartTable from '@/components/charts/ChartTable'
import ChartTableRender from '@/components/charts/ChartTableRender'
import PdfExport from '@/components/pdfExport'

// am4core.useTheme(am4themesAnimated)
am4core.useTheme(am4themesMaterial)
am4core.useTheme(am4themesEfdThemeAchr)
// am4core.options.onlyShowOnViewport = true
am4core.options.queue = true
export default {
  name: 'DashboardDataQualityContact',
  components: {
    BaseLoader,
    LastUpdateTime,
    Filters,
    WidgetKpi,
    ChartBar,
    ChartBarRender,
    ChartLine,
    ChartLineRender,
    ChartPie,
    ChartPieRender,
    ChartTable,
    ChartTableRender,
    PdfExport
  },
  data () {
    return {
      id: 'DataQuality',
      name: 'Data Quality Analytics',
      charts: [
        {
          key: 'DataQuality_kpiTotalContacts',
          title: 'chart.title.DataQuality_kpiTotalContacts',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validEmail',
          title: 'chart.title.DataQuality_validEmail',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validTelephone',
          title: 'chart.title.DataQuality_validTelephone',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validStreet',
          title: 'chart.title.DataQuality_validStreet',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validZip',
          title: 'chart.title.DataQuality_validZip',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validStreetNumber',
          title: 'chart.title.DataQuality_validStreetNumber',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validCity',
          title: 'chart.title.DataQuality_validCity',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        },
        {
          key: 'DataQuality_validAddress',
          title: 'chart.title.DataQuality_validAddress',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {}
        }
      ],
      pdfExport: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {},
      hideCharts: []
    }
  },
  computed: {
    ...mapGetters([
      'selectedFilters', 'getCharts', 'getChartByKey', 'translation'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    // remove charts if listed in config
    if (process.env.VUE_APP_HIDE_CHARTS) {
      try {
        this.hideCharts = JSON.parse(process.env.VUE_APP_HIDE_CHARTS)
        if (this.hideCharts.length) {
          this.charts.forEach((chart, index) => {
            if (this.hideCharts.indexOf(chart.key) > -1) {
              this.charts.splice(index, 1)
            }
          })
        }
      } catch (error) {
        this.$log.error('Parse: ', error)
        return
      }
    }

    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .ffu-analytics {
  }
  @media only screen and (max-device-width: 700px) {
    .ffu-analytics {
    }
  }
</style>
